import { formatDateTimeExact } from '@chikara/utils';
import type { Transaction } from '@/features/card/types/account.types';
import { STATUS_TRANSACTION, TYPE_TRANSACTION } from '@/features/dashboard/constants/dashboard.constants';

/**
 * Fila de movimientos ya normalizada para la tabla y el CSV.
 */
export interface DashboardMovementRow extends Transaction {
  report?: boolean;
  statusName?: string;
  movement_mobile?: string;
  cdate_mobile?: string;
  pan_masked?: string;
  narrative?: string;
}

/**
 * Normaliza una transacción cruda de `account-list-tx` al view-model de la tabla.
 * Se usa tanto en el listado paginado como en el export.
 */
export function mapMovementRow(tx: any): DashboardMovementRow {
  return {
    uuid: tx?.uuid,
    amount: tx?.amount,
    email: tx?.user?.email,
    currency: tx?.currency,
    movement: {
      description: tx?.description || 'No aplica',
      subcategory: `${tx?.card?.pan_masked?.slice(-4) || '----'} / Realizado por ${tx?.user?.fullname?.trim() || tx?.user?.email}`,
    },
    type: (tx?.type && TYPE_TRANSACTION[tx.type]) || tx?.type,
    status: tx?.status,
    report:
      tx?.status === 'settled' ||
      tx?.status === 'on_transit' ||
      tx?.status === 'approved' ||
      tx?.status === 'pending',
    statusName: (tx?.status && STATUS_TRANSACTION[tx.status]) || tx?.status,
    cdate: formatDateTimeExact(tx?.cdate),
    tracking_key: tx?.tracking_key || '',
    narrative: tx?.remote_account?.narrative || '',
    movement_mobile: tx?.description || 'No aplica',
    cdate_mobile: formatDateTimeExact(tx?.cdate),
    pan_masked: tx?.card?.pan_masked?.slice(-4) || '----',
  };
}
